import { render } from "./Blank.vue?vue&type=template&id=33c7bca1&scoped=true&lang=pug"
import script from "./Blank.vue?vue&type=script&lang=js"
export * from "./Blank.vue?vue&type=script&lang=js"

import "./Blank.vue?vue&type=style&index=0&id=33c7bca1&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c7bca1"]])

export default __exports__